import { useSelector } from 'react-redux'

import DashboardNavbarItem from './DashboardNavbarItem'

import { selectRole } from '../../../../routing/fetchingfunction/user/user.reducer'

import { dashboardLinks } from 'constants/global'

export const DashboardNavbar = () => {
  const role = useSelector(selectRole)

  const dashboardLinksList = dashboardLinks(role)

  const dashboardNavbarContent = dashboardLinksList.map((dashboardLink) => {
    return (
      dashboardLink.isVisible && (
        <DashboardNavbarItem
          key={dashboardLink.href}
          href={dashboardLink.href}
          label={dashboardLink.label}
          icon={dashboardLink.icon}
        />
      )
    )
  })

  return (
    <ul className="mb-[10px] flex items-center justify-center mx-auto gap-x-3">
      {dashboardNavbarContent}
    </ul>
  )
}

export default DashboardNavbar
